<div id="confirmation-details-section">
    <ng-container *ngIf="showPositionsOrMultipleAccounts(); then displayFromMulitpleTransfers; else displayFromSingleTransfer;"></ng-container>
    <ng-template #displayFromMulitpleTransfers>
        <div class="caseId-container" *ngIf="getCaseId()" data-testid="caseId">
            <span id="caseId-label">Case ID: </span>
            <span class="confirmation-detail" id="caseId-value">{{getCaseId()}}</span>
        </div>
        <div *ngIf="getStatus()" class="status-container">
            <span id="status-label">Status: </span>
            <span class="confirmation-detail" id="status-value">{{getStatus()}}</span>
        </div>
        <div *ngIf="getRequestedDate() + getRequestedTime()" class="timestamp-container">
        <span id="timestamp-label">{{dateAndTimeStampLabelMultipleToAccount}}</span><span class="confirmation-detail"
                id="timestamp-value">{{getRequestedDate() | formattedDate}} {{getRequestedTime() | formattedTime}}</span>
        </div>
        <div *ngIf="getSource()" class="source-container" data-testid="source">
            <span id="source-label">Source: </span>
            <span class="confirmation-detail" id="source-value">{{getSource()}}</span>
        </div>
        <div class="initiatedBy-container" data-testid="initiatedBy">
            <span id="initiatedBy-label">Initiated by: </span>
            <span class="confirmation-detail" id="initiatedBy-value">{{getInitiatedBy()}}</span>
        </div>
        <div *ngIf="canRelease && draftInContext" class="initiatedBy-container" data-testid="releasedBy">
            <span id="releasedBy-label">Released by: </span>
            <span class="confirmation-detail" id="releasedBy-value">{{getUser()}}</span>
        </div>
        <div *ngIf="isFromEdit" class="lastModifiedBy-container" data-testid="lastModifiedBy">
            <span id="lastModifiedBy-label">Last modified by: </span>
            <span class="confirmation-detail" id="lastModifiedBy-value">{{lastModifiedBy}}</span>
        </div>
    </ng-template>
    <ng-template #displayFromSingleTransfer>
        <div [ngClass]="useCondensedLayout ? 'condensed-container' : 'container'" *ngIf="(caseId$ | async)">
            <span id="caseId-label" [ngClass]="{'condensed-details-label': useCondensedLayout}">Case ID: </span>
            <span id="caseId-value" [ngClass]="useCondensedLayout ? 'condensed-details-data' : 'confirmation-detail'">{{(caseId$ | async)}}</span>
        </div>
        <div [ngClass]="useCondensedLayout ? 'condensed-container' : 'container'">
            <span id="status-label" [ngClass]="{'condensed-details-label': useCondensedLayout}">Status: </span>
            <span [ngClass]="useCondensedLayout ? 'condensed-details-data' : 'confirmation-detail'" id="status-value">{{status}}</span>
        </div>
        <div [ngClass]="useCondensedLayout ? 'condensed-container' : 'container'">
            <span id="timestamp-label" [ngClass]="{'condensed-details-label': useCondensedLayout}">{{dateAndTimeStampLabel}}</span>
            <span [ngClass]="useCondensedLayout ? 'condensed-details-data' : 'confirmation-detail'"
                id="timestamp-value">{{(requestedDate$ | async)! | formattedDate}} {{(requestedTime$ | async)! |
                formattedTime}}</span>
        </div>
        <div *ngIf="getSource()" [ngClass]="useCondensedLayout ? 'condensed-container' : 'container'" data-testid="source">
          <span id="source-label" [ngClass]="{'condensed-details-label': useCondensedLayout}">Source: </span>
          <span [ngClass]="useCondensedLayout ? 'condensed-details-data' : 'confirmation-detail'" id="source-value">{{getSource()}}</span>
      </div>
      <div [ngClass]="useCondensedLayout ? 'condensed-container' : 'container'" data-testid="initiatedBy">
          <span id="initiatedBy-label" [ngClass]="{'condensed-details-label': useCondensedLayout}">Initiated by: </span>
          <span [ngClass]="useCondensedLayout ? 'condensed-details-data' : 'confirmation-detail'" id="initiatedBy-value">{{getInitiatedBy()}}</span>
      </div>
      <div *ngIf="canRelease && draftInContext" [ngClass]="useCondensedLayout ? 'condensed-container' : 'container'" data-testid="releasedBy">
        <span id="releasedBy-label" [ngClass]="{'condensed-details-label': useCondensedLayout}">Released by: </span>
        <span [ngClass]="useCondensedLayout ? 'condensed-details-data' : 'confirmation-detail'" id="releasedBy-value">{{getUser()}}</span>
      </div>
      <div *ngIf="isFromEdit" [ngClass]="useCondensedLayout ? 'condensed-container' : 'container'" data-testid="lastModifiedBy">
        <span id="lastModifiedBy-label" [ngClass]="{'condensed-details-label': useCondensedLayout}">Last modified by: </span>
        <span [ngClass]="useCondensedLayout ? 'condensed-details-data' : 'confirmation-detail'" id="lastModifiedBy-value">{{lastModifiedBy}}</span>
    </div>
    </ng-template>
</div>
